export default "__VITE_ASSET__Caqhu5DK__"